import React from 'react'
import { CheckboxWrapper } from './AppCheckBox.style'
import { AppToolTip } from 'components/Common/AppToolTip/AppToolTip.component'
import { AppToolTipIcon } from 'components/Common/AppToolTip/AppToolTipIcon'
import { v4 as uuidv4 } from 'uuid'
interface AppCheckBoxProps {
  value: boolean
  label?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  id?: string
  variant?: 'tick' | 'indeterminate'
  onBlur?: (value) => void
  toolTipText?: string
}

export const AppCheckBox: React.FC<AppCheckBoxProps> = ({
  value,
  onChange,
  onBlur,
  disabled = false,
  label,
  id,
  variant = 'tick',
  toolTipText,
}) => {
  // Generate a unique id if none provided
  const checkboxId = id || `checkbox-${uuidv4()}`

  return (
    <div className="flex items-baseline gap-2 relative w-full">
      <CheckboxWrapper
        id={checkboxId}
        onChange={onChange}
        type="checkbox"
        checked={value}
        disabled={disabled}
        className={`${
          value
            ? variant === 'indeterminate'
              ? "!bg-[url('assets/svgs/minus-small.svg')]"
              : "!bg-[url('assets/svgs/WhiteTick.svg')]"
            : ''
        }`}
        onBlur={onBlur}
      />
      {label && (
        <label
          htmlFor={checkboxId}
          className="text-black font-regular text-base font-normal tracking-normal leading-normal mt-[-1px] relative flex-1 break-words cursor-pointer"
        >
          {label}
        </label>
      )}
      {toolTipText && (
        <div className="self-start">
          <AppToolTip name="ToolTip" text={toolTipText} variant="primary" place="bottom">
            <AppToolTipIcon />
          </AppToolTip>
        </div>
      )}
    </div>
  )
}
